<template>
  <div>
    <core-modal-header>Save Options</core-modal-header>

    <core-modal-body>
      <div class="grid grid-cols-2 gap-3">
        <button
          type="button"
          class="text-left border rounded p-4 flex flex-col transition-colors aspect-square"
          :class="selectedMode === 'clip'
            ? 'border-sage bg-charcoal-50 ring-1 ring-sage'
            : 'border-charcoal-200 hover:border-sage hover:bg-charcoal-50'"
          @click="selectedMode = 'clip'"
        >
          <div class="font-medium font-bold text-charcoal-900">Export As Separate Videos</div>
          <div class="text-sm text-charcoal-600">Creates a new video file for each clip.</div>
        </button>

        <button
          type="button"
          class="text-left border rounded p-4 flex flex-col transition-colors aspect-square"
          :class="selectedMode === 'cut'
            ? 'border-sage bg-charcoal-50 ring-1 ring-sage'
            : 'border-charcoal-200 hover:border-sage hover:bg-charcoal-50'"
          @click="selectedMode = 'cut'"
        >
          <div class="font-medium  font-bold text-charcoal-900">Export as One Combined Video</div>
          <div class="text-sm text-charcoal-600">Creates a single video using all clips in sequence.</div>
        </button>
      </div>
    </core-modal-body>

    <core-modal-footer>
      <u-button size="xl" color="charcoal" variant="soft" @click="props.modal.close()">Cancel</u-button>
      <u-button size="xl" :disabled="!selectedMode" @click="confirmSelection">Save</u-button>
    </core-modal-footer>
  </div>
</template>

<script setup>
  const emit = defineEmits(['make-clips', 'cut-regions']);
  const props = defineProps({
    modal: Object
  });
  const selectedMode = ref('');

  function confirmSelection() {
    if (selectedMode.value === 'clip') {
      emit('make-clips');
    } else if (selectedMode.value === 'cut') {
      emit('cut-regions');
    } else {
      return;
    }
    props.modal.close();
  }
</script>
